export default __webpack_public_path__ + "static/media/CNo.68-5.61d1f5e9.jpg";